import useObservable from 'libraries/front-end-core/hooks/useObservable'
import { User, $emailPreferences, $primaryAol } from 'services/SessionService'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import { EmailPreferences, SharedEmailPreferences, User as UserT } from 'types/User'
import AolPreferences from './AolPreferences'
import { RESPONSE_PENDING } from 'libraries/front-end-core/constants/responses'

const Preferences = (): JSX.Element => {
  const preferences: EmailPreferences | SharedEmailPreferences = useObservable($emailPreferences, RESPONSE_PENDING)
  const user: UserT = useObservable(User, RESPONSE_PENDING)
  const primaryAol: string = useObservable($primaryAol, RESPONSE_PENDING)
  return (
    <ResponseConsumer
      responses={[preferences, user]}
      content={() => <AolPreferences accessRoles={user.accessRoles} preferences={preferences} primaryAol={primaryAol} />}
    />
  )
}

export default Preferences
